function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M17.34,5.61,15.78,7.16a2.5,2.5,0,0,1-3.53,0l-.31-.31L10.83,8a.56.56,0,0,1-.4.17A.58.58,0,0,1,10,8a.56.56,0,0,1,0-.79l1.11-1.11-.31-.31a2.52,2.52,0,0,1,0-3.54L12.39.66A8.87,8.87,0,0,0,9,0,9,9,0,0,0,0,9a8.85,8.85,0,0,0,.66,3.38l1.56-1.55a2.49,2.49,0,0,1,3.53,0l.31.31,1.09-1.09a.57.57,0,0,1,.8,0,.56.56,0,0,1,0,.79L6.86,11.93l.31.31a2.51,2.51,0,0,1,0,3.54L5.61,17.33A8.87,8.87,0,0,0,9,18a9,9,0,0,0,9-9A8.9,8.9,0,0,0,17.34,5.61ZM11.54,5l.31.31,1.79-1.79a.56.56,0,0,1,.8.79L12.65,6.14l.31.31a1.53,1.53,0,0,0,2.12,0l1.8-1.8a9.1,9.1,0,0,0-3.53-3.54L11.54,2.92A1.51,1.51,0,0,0,11.54,5ZM6.46,13l-.31-.31-1.79,1.8a.57.57,0,0,1-.8-.8l1.8-1.79-.31-.31A1.48,1.48,0,0,0,4,11.1a1.45,1.45,0,0,0-1.06.44l-1.81,1.8a9,9,0,0,0,3.54,3.54l1.8-1.81a1.5,1.5,0,0,0,0-2.12Z",
  fill: "#848890"
}), React.createElement("path", {
  d: "M8,10.84,6.86,11.93l.31.31a2.51,2.51,0,0,1,0,3.54L5.61,17.33a8.25,8.25,0,0,1-1-.45l1.8-1.81a1.5,1.5,0,0,0,0-2.12l-.31-.31-1.79,1.8a.57.57,0,0,1-.8-.8l1.8-1.79-.31-.31A1.48,1.48,0,0,0,4,11.1a1.45,1.45,0,0,0-1.06.44l-1.81,1.8a8.46,8.46,0,0,1-.46-1l1.56-1.55a2.49,2.49,0,0,1,3.53,0l.31.31,1.09-1.09a.57.57,0,0,1,.8,0A.56.56,0,0,1,8,10.84Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M17.34,5.61,15.78,7.16a2.5,2.5,0,0,1-3.53,0l-.31-.31L10.83,8a.56.56,0,0,1-.4.17A.58.58,0,0,1,10,8a.56.56,0,0,1,0-.79l1.11-1.11-.31-.31a2.52,2.52,0,0,1,0-3.54L12.39.66a10.52,10.52,0,0,1,1,.45L11.54,2.92a1.51,1.51,0,0,0,0,2.12l.31.31,1.79-1.79a.56.56,0,0,1,.8.79L12.65,6.14l.31.31a1.53,1.53,0,0,0,2.12,0l1.8-1.8A8.46,8.46,0,0,1,17.34,5.61Z",
  fill: "#fff"
})));

function SvgDisconnect(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/disconnect.cd7359fb.svg";
export { SvgDisconnect as ReactComponent };